import * as ACTION_TYPES from "../types";

let initialState = {
  kioskDefinitionList: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_KIOSK_DEFINITIONS:
      return { ...state, kioskDefinitionList: action.data };
    default:
      return state;
  }
};
